import React, { useState, useEffect, useRef } from 'react'
import { useBeforeunload } from 'react-beforeunload'
import { Input, List, Layout, PageHeader, Button } from 'antd'
import { MenuUnfoldOutlined, MenuFoldOutlined, CloseCircleTwoTone } from '@ant-design/icons'
import axios from 'axios'

import SideBar from './SideBar'
import MessageItem from './MessageItem'

import { participantsURL } from 'global'

export default function ScreenChat ({ nickname, messages, participants, sendMessageCallback, onDisconect, deleteBody }) {
  const [sideBarVisible, setSideBarVisible] = useState(true)
  const [searchText, setSearchText] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const { Content, Footer, Header } = Layout
  const { Search } = Input
  const searchRef = useRef(null)

  useBeforeunload(event => {
    axios.delete(participantsURL, { data: deleteBody }).then(a => {})
  })

  useEffect(() => {
    searchRef.current.input.focus()
    return () => {
      axios.delete(participantsURL, { data: deleteBody }).then(a => {})
    }
  }, [])

  const MenuButton = ({ visible, onChange }) => {
    if (visible) {
      return <MenuFoldOutlined className='trigger' onClick={() => onChange(!visible)} />
    } else {
      return <MenuUnfoldOutlined className='trigger' onClick={() => onChange(!visible)} />
    }
  }

  return (
    <Layout className='layout' style={{ margin: '0px', height: '100vh' }}>
      <SideBar visible={sideBarVisible} users={participants} />
      <Layout style={{ height: '100vh' }}>
        <PageHeader
          title={<MenuButton visible={sideBarVisible} onChange={setSideBarVisible} />}
          subTitle='ScrumbleCheat Chatting Room'
          extra={[<CloseCircleTwoTone style={{ fontSize: '20px' }} onClick={() => onDisconect()} />]}
        ></PageHeader>
        <Layout style={{ padding: '0px 0px' }}>
          <Content style={{ background: 'transparent', padding: '20px 20px' }}>
            <List
              dataSource={messages}
              renderItem={item => (
                <List.Item style={{ background: 'transparent', padding: '0px' }}>
                  <MessageItem item={item} myselfIdentifier={nickname} />
                </List.Item>
              )}
            />
          </Content>
          <Footer style={{ background: 'blue', padding: '0px' }}>
            <Search
              placeholder='Enter your message here'
              value={searchText}
              enterButton='Send'
              size='large'
              onChange={e => {
                setSearchText(e.target.value)
              }}
              onSearch={async message => {
                setIsSearching(true)
                await sendMessageCallback(message)
                setSearchText('')
                setIsSearching(false)
              }}
              loading={isSearching}
              ref={searchRef}
            />
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  )
}
